(() => {
  function openBrandSection(section) {
    const heading = section.querySelector(".collapsible-heading");
    if (heading && !section.classList.contains("active")) {
      heading.click();
    }
  }

  function revealHashSection() {
    const section = document.getElementById(window.location.hash.slice(1));
    if (section && section.classList.contains("kr-brand-row")) {
      openBrandSection(section);
    }
  }

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest("a[data-kr-brand-link]");
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    openBrandSection(target);
    requestAnimationFrame(() => {
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: "start", behavior: "instant" });
    });
  });

  window.addEventListener("hashchange", revealHashSection);
  customElements.whenDefined("collapsible-block").then(revealHashSection);
})();
